import { render, staticRenderFns } from "./MyLegalShops.vue?vue&type=template&id=4e039424"
import script from "./MyLegalShops.vue?vue&type=script&lang=js"
export * from "./MyLegalShops.vue?vue&type=script&lang=js"
import style0 from "./MyLegalShops.vue?vue&type=style&index=0&id=4e039424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports